import React, { useState } from 'react'

import "./navBar.css"

import clpLogo from "../../../assets/clp-logo.png";
import SideBar from '../../components/sideBar';

const NavBar = () => {

 



  return (
    <div className='mobileNavBar-container' >
<SideBar pageWrapId={'page-wrap'} outerContainerId={'outer-container'}   />
            <img src={clpLogo} className='clpLogoMobile' />

    </div>
  )
}

export default NavBar